import {
    ATC_LIST,
    ATC_LIST_SUCCESS,
    ATC_LIST_ERROR
} from '../actions';

const INIT_STATE = {
    loading: true,
    list: {
        header: {
            name: 'code',
            order: 'sorted-asc'
        },
        page: {
            current: 1,
            rows: 10
        }
    },
    error: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ATC_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }
        case ATC_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case ATC_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        default:
            return { ...state };
    }
};